export default "Optimisation de la production d'air comprimé : fiche CEE IND-UT-117. Réparation fuites (détection ultrasonore), baisse de la pression réseau, récupération de chaleur compresseur, pilotage intelligent multi-compresseurs.";
